import { api, makeApiRequest } from 'api/_init'

/**
 * @typedef {Object} GoogleTestCampaignPayload
 * @property {string} ad_account_id - Google Ads customer ID
 * @property {string} [conversion_action_id] - Google Ads conversion action ID (optional)
 */

/**
 * @typedef {Object} GoogleTestCampaign
 * @property {number} id
 * @property {string} platform - 'GOOGLE'
 * @property {string} partner_id
 * @property {string} ad_account_id
 * @property {string} [campaign_id]
 * @property {string} [campaign_name]
 * @property {string} [campaign_type] - 'DISPLAY'
 * @property {string} [adset_id] - ad group ID
 * @property {string} [ad_id]
 * @property {Object} assets
 * @property {string} [task_id]
 * @property {Object} [error]
 * @property {string} [error_category]
 * @property {string} status
 * @property {string} [stage]
 * @property {string} date_created
 * @property {string} date_last_updated
 */

const googleTestCampaignApi = {
  /**
   * @param {GoogleTestCampaignPayload} payload
   * @returns {Promise<{data?: GoogleTestCampaign, error?: any}>}
   */
  createTestCampaign: async (payload) =>
    makeApiRequest(api, 'post', '/integrations/connect/google/test-campaign', payload, {
      timeout: 0,
    }),

  /**
   * @returns {Promise<{data?: {ongoing_campaign: GoogleTestCampaign|null}, error?: any}>}
   */
  getOngoingCampaign: async () =>
    makeApiRequest(api, 'get', '/integrations/connect/google/test-campaign'),

  /**
   * @param {number} campaignId
   * @returns {Promise<{data?: GoogleTestCampaign, error?: any}>}
   */
  getTestCampaignById: async (campaignId) =>
    makeApiRequest(api, 'get', `/integrations/connect/google/test-campaign?id=${campaignId}`),
}

export default googleTestCampaignApi
